import { withSvgIcon } from './withSvgIcon';

export const WalletDownIcon = withSvgIcon(
  <>
    <path
      d="M15 4.25H15.75V2.75H15V4.25ZM5 4.25H15V2.75H5V4.25ZM16.25 9V14.5H17.75V9H16.25ZM15 6.25H4V7.75H15V6.25ZM2.25 5.5V9.5H3.75V5.5H2.25ZM15 15.75H10V17.25H15V15.75ZM4 6.25C3.86193 6.25 3.75 6.13807 3.75 6H2.25C2.25 6.9665 3.0335 7.75 4 7.75V6.25ZM5 2.75C3.48122 2.75 2.25 3.98122 2.25 5.5H3.75C3.75 4.80964 4.30964 4.25 5 4.25V2.75ZM16.25 14.5C16.25 15.1904 15.6904 15.75 15 15.75V17.25C16.5188 17.25 17.75 16.0188 17.75 14.5H16.25ZM17.75 9C17.75 7.48122 16.5188 6.25 15 6.25V7.75C15.6904 7.75 16.25 8.30964 16.25 9H17.75Z"
      fill="currentColor"
    />
    <circle cx="14" cy="11.5" r="1" fill="currentColor" />
    <path
      d="M5 12L5 17M5 17L2 14M5 17L8 14"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
